/** * ログインアカウントコンポーネント */
<template>
  <div class="my-account">
    <div class="user-nav">
      <div class="login-user">
        <img class="profile-icon white-border" v-bind:src="profileImagePath" />
        <div class="user-info">
          <p class="user-id">
            {{ userId }}
          </p>
          <p v-ifield-b-tooltip.hover v-bind:title="userName" class="user-name">
            {{ userName }}
          </p>
        </div>
        <img class="user-menu-arrow" src="@/assets/ifield/img_icon_arrow.png" />
        <div class="user-menu">
          <a v-on:click="$_clickProfile" v-t="'appMyAccount.userInformation'" />
          <a
            v-on:click="$_clickLoginHistory"
            v-t="'appMyAccount.loginHistory'"
          />
          <a
            v-on:click="$_clickSetting"
            v-t="'appMyAccount.personalSettings'"
          />
          <a
            v-on:click="$_clickAppInfo"
            v-t="'appMyAccount.applicationInformation'"
          />
          <a
            v-on:click="$_clickChangePassword"
            v-t="'appMyAccount.changePassword'"
          />
          <a v-on:click="$_logout" v-t="'appMyAccount.logout'" />
        </div>
      </div>
    </div>
    <loading-mask isFullScreen v-bind:isLoading="isLoggingOut" />
  </div>
</template>
<script>
import { RestApiClient } from 'ifield-core-components'
import { useHandleApiError } from '@/composables/UseHandleApiError.js'

export default {
  name: 'AppMyAccount',
  components: {},
  props: {
    /**
     * 表示したいユーザーID
     */
    userId: {
      type: String,
      required: true,
    },
  },
  setup(props, context) {
    const { handleApiError } = useHandleApiError(props, context)
    return { handleApiError }
  },
  data: function () {
    return {
      /**
       * アカウント情報
       * @type {Object}
       */
      accountProfile: null,
      /**
       * ログインユーザーのユーザーID
       * @type {number}
       */
      id: null,
      /**
       * ログインユーザーのユーザー名
       * @type {string}
       */
      userName: '',
      /**
       * ログインユーザーのプロフィール画像情報
       * @type {Object}
       */
      containerImagePath: null,
      /**
       * ログアウト中フラグ
       * @type {Boolean}
       */
      isLoggingOut: false,
    }
  },
  computed: {
    /**
     * アイコン画像のパスを更新
     */
    profileImagePath: function () {
      // ダウンロードファイルAPI
      let url = RestApiClient.createApiUrl('download_file')
      let params = url.searchParams
      params.append('thumbnail', 1)
      if (this.id) {
        params.append('id', this.id)
      }
      if (this.containerImagePath) {
        params.append(
          'attach_file_type',
          this.containerImagePath.attach_file_type
        )
      }
      return url.toString()
    },
  },
  updated: function () {},
  mounted: function () {
    this.$_showAccount()
    this.$log.info('MyAccount mounted!')
  },
  methods: {
    /**
     * 個人設定クリックイベント
     */
    $_clickSetting: function () {
      this.$emit('myaccount-click-setting')
    },
    /**
     * ログイン履歴クリックイベント
     */
    $_clickLoginHistory: function () {
      this.$emit('myaccount-click-login-history')
    },
    /**
     * ユーザー情報クリックイベント
     */
    $_clickProfile: function () {
      this.$emit('myaccount-click-profile', this.accountProfile)
    },
    /**
     * アプリ情報クリックイベント
     */
    $_clickAppInfo: function () {
      this.$emit('myaccount-click-appinfo')
    },
    /**
     * パスワード変更クリックイベント
     */
    $_clickChangePassword: function () {
      this.$emit('myaccount-click-change-password', this.accountProfile)
    },
    /**
     * ログアウト
     */
    $_logout: async function () {
      this.$_showLoading()

      try {
        // ログアウトAPI実行
        await RestApiClient.executePostApi(RestApiClient.createApiUrl('logout'))
        //storeのユーザーIDをクリア
        this.$store.dispatch('logout')
        //ログインページ起動
        this.$router.push('/login')
      } catch (error) {
        this.handleApiError(error)
      } finally {
        this.$_hideLoading()
      }
    },
    /**
     *  アカウントを取得して表示する
     */
    $_showAccount: function () {
      RestApiClient.executeGetApi(
        RestApiClient.createApiUrl('user/status/myaccount')
      )
        .then((json) => {
          this.$_setAccounts(json)
        })
        .catch((error) => {
          this.handleApiError(error)
        })
    },
    /**
     * アカウント情報を設定する
     * @param {object} json APIから取得したjson
     */
    $_setAccounts: function (json) {
      this.accountProfile = json.data
      this.id = this.accountProfile.id
      this.userName = this.accountProfile.user_name
      this.containerImagePath = this.accountProfile.profile_image
      this.$log.debug('setAccounts', this.accountProfile)
    },

    /**
     * ローディングを表示する
     */
    $_showLoading: function () {
      this.isLoggingOut = true
    },

    /**
     * ローディングを非表示にする
     */
    $_hideLoading: function () {
      this.isLoggingOut = false
    },
  },
}
</script>

<style lang="scss" scoped>
.user-nav {
  width: auto;
  height: $navigation-bar-height;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.login-user {
  height: 64px;
  padding-left: 16px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: #007055;
  position: relative;
  transition: 0.2s;

  &:hover {
    background-color: #108065;
    cursor: pointer;
  }

  .user-menu-arrow {
    display: block;
    width: 10px;
    height: 32px;
    margin: 0 12px;
  }
}

.user-info {
  width: 120px;
  height: 40px;
  margin-left: 10px;
  border-right: 1px solid #ffffff;

  .user-id {
    color: rgba(255, 255, 255, 0.9);
    font-size: 0.7em;
    line-height: 18px;
    margin-bottom: 2px;
  }

  .user-name {
    max-width: 100%;
    color: #ffffff;
    font-size: 0.8em;
    font-weight: bold;
    line-height: 20px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.profile-icon {
  display: block;
  width: 40px;
  height: 40px;
  border: 1px solid #eeeeee;
  border-radius: 50%;

  &.white-border {
    border: 1px solid #ffffff;
  }
}

.user-menu {
  width: auto;
  height: 0;
  border: 1px solid transparent;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 64px;
  right: 0;
  overflow: hidden;
  transition: 0.2s;

  .login-user:hover & {
    height: auto;
    border: 1px solid #e8e8e8;
  }

  a {
    display: block;
    width: 160px;
    height: 40px;
    padding: 10px;
    color: #333333;
    font-size: 0.8em;
    line-height: 20px;
    text-decoration: none;
    border-bottom: 1px solid #e8e8e8;
    background-color: #ffffff;
    transition: 0.2s;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background-color: #f6f6f6;
    }
  }
}
</style>
